// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"7b51c7e7","311":"789aa69b","488":"c12f5545","666":"0cb6691d","940":"2d3cd567"}[chunkId] + ".chunk.js";
};